import { ChromeAppMessage } from 'Environment/ChromeApp/types';
import { clientType } from 'Environment/getClientType';
import { HTML5Client } from 'Environment/launchResource/html5Client';
import {
	invokeMessageHandler,
	preHtml5LaunchMessages,
} from 'GlobalAppConfigService/ChromeAppHtml5/preHtml5LaunchMessages';
import { Dependencies } from 'GlobalAppConfigService/types';
import { GacsHtmlChromeAppTransportBase } from './gacsTransportBase';

export class GacsHtml5Transport extends GacsHtmlChromeAppTransportBase {
	// During WSUI login, the HTML5 client may not available so this is optional.
	private readonly html5client?: HTML5Client;

	public constructor(dependencies: Dependencies, html5client?: HTML5Client) {
		super(dependencies, clientType.html5);
		this.html5client = html5client;
	}

	protected postMessage(message: ChromeAppMessage): void {
		if (preHtml5LaunchMessages.includes(message.header.type)) {
			invokeMessageHandler(message);
			return;
		}

		this.html5client?.sendEvent(message);
	}
}
